import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/episodes", label: "全部剧集", desc: "分集剧情一览", icon: "ri-play-list-2-line" },
  { to: "/characters", label: "角色介绍", desc: "人物关系图谱", icon: "ri-team-line" },
  { to: "/news", label: "影视资讯", desc: "播出动态速递", icon: "ri-newspaper-line" },
  { to: "/about", label: "关于我们", desc: "站点定位说明", icon: "ri-information-line" },
];

export default function QuickNav() {
  return (
    <div className="grid grid-cols-2 gap-3">
      {quickLinks.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className="group flex flex-col gap-2 p-4 rounded-lg bg-secondary-50 border border-secondary-200 hover:border-accent-300 hover:bg-accent-50 transition-colors cursor-pointer"
        >
          <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-white transition-colors">
            <i className={`${link.icon} text-xl`} />
          </span>
          <span>
            <span className="block font-medium text-foreground-900 text-sm">{link.label}</span>
            <span className="block text-xs text-foreground-500 mt-0.5">{link.desc}</span>
          </span>
        </Link>
      ))}
    </div>
  );
}